import React, { useEffect, useState } from 'react';

import { Box, Paper, TextareaAutosize, Typography } from '@mui/material';

import { Reason } from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { InsuranceLabs } from '../../../../tasks/types/insuranceLabs';
import { ReasonsChoicePanel } from '../../ReasonsChoicePanel';
import { RequiredFieldErrorBar } from '../../RequiredFieldErrorBar';
import styles from '../../styles.module.scss';

export const InsuranceLabsLayout = ({
  data,
  setData,
  isExpanded,
  reasons,
  error,
  description,
}: {
  data: InsuranceLabs;
  setData: React.Dispatch<React.SetStateAction<InsuranceLabs>>;
  isExpanded: boolean;
  reasons: Reason[];
  error: boolean;
  description: string;
}) => {
  const [reasonDescription, setReasonDescription] = useState(
    data.reasonDescription || '',
  );
  const [selectedReasons, setSelectedReasons] = useState(
    data.reason || ([] as string[]),
  );
  const [approxDateOfLabs, setApproxDateOfLabs] = useState(
    data.approxDateOfLabs ?? '',
  );

  useEffect(() => {
    const newData = {} as InsuranceLabs;
    if (isExpanded) {
      newData.reason = selectedReasons;
      newData.reasonDescription = reasonDescription;
      newData.approxDateOfLabs = approxDateOfLabs;
    } else {
      setReasonDescription('');
      setSelectedReasons([] as string[]);
      setApproxDateOfLabs('');
    }
    setData(newData);
  }, [isExpanded, reasonDescription, selectedReasons.length, approxDateOfLabs]);

  return (
    <Box>
      {error && (
        <Box mb={1}>
          <RequiredFieldErrorBar />
        </Box>
      )}

      <Box>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {Resource.DESCRIPTION}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2">{description}</Typography>
      </Box>

      <Box mt={3}>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {Resource.APPROX_LAB_DATE}
        </Typography>
      </Box>
      <Box>
        <TextareaAutosize
          name="approx_lab_date"
          data-tid="approxlabdate-textarea"
          placeholder="Provide the approximate date"
          className={styles.MUTextareaInput}
          onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
            setApproxDateOfLabs(ev.currentTarget.value);
          }}
          value={approxDateOfLabs}
          minRows={3}
        />
      </Box>

      <Box mt={3}>
        <Paper
          elevation={0}
          style={{ backgroundColor: 'var(--neutrals-night-10)' }}
        >
          <Box p={1.5} pt={1.5}>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              {Resource.ORDER_REASON}
            </Typography>
            <ReasonsChoicePanel
              reasons={reasons}
              selectedReasons={selectedReasons}
              selectReasonsCallback={setSelectedReasons}
            />
            <Box mt={2}>
              <TextareaAutosize
                name="reason"
                data-tid="insurance-labs-reason-textarea"
                placeholder="Describe the reason"
                className={styles.MUTextareaInput}
                onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
                  setReasonDescription(ev.currentTarget.value);
                }}
                value={reasonDescription}
                minRows={3}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
